module.exports = __webpack_public_path__ + "img/kumo_1.f1d8e2a3.svg";